export type AMLScenario = "default" | "profile" | "contribution";

export enum AMLRedirect {
    Profile = "profile",
    Default = "default",
    Contribution = "contribution",
    Strategy = "strategy",
    ContributionWithQuestionare = "contributionWithQuestionare",
}
